/**
 * Inline-Icons (stroke = currentColor, damit sie den Token-Farben folgen).
 * Bewusst ohne externe Icon-Bibliothek: kleiner Bundle, konsistente Strichstärke.
 */

import type { SVGProps } from 'react';

export type IconProps = SVGProps<SVGSVGElement> & { groesse?: number };

function Basis({ groesse = 20, children, ...rest }: IconProps) {
  return (
    <svg
      width={groesse}
      height={groesse}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.7}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconObjekte = (p: IconProps) => (
  <Basis {...p}>
    <path d="M3 21h18" />
    <path d="M5 21V6l7-3 7 3v15" />
    <path d="M9 21v-4h6v4" />
    <path d="M9 9h.01M15 9h.01M9 13h.01M15 13h.01" />
  </Basis>
);

export const IconAbrechnungen = (p: IconProps) => (
  <Basis {...p}>
    <path d="M6 3h12v18l-3-2-3 2-3-2-3 2V3z" />
    <path d="M9.5 8h5M9.5 12h5M9.5 16h2.5" />
  </Basis>
);

export const IconGlocke = (p: IconProps) => (
  <Basis {...p}>
    <path d="M6 9a6 6 0 0 1 12 0c0 5 2 6 2 6H4s2-1 2-6z" />
    <path d="M10.5 20a2 2 0 0 0 3 0" />
  </Basis>
);

export const IconAdmin = (p: IconProps) => (
  <Basis {...p}>
    <path d="M12 3l7 3v5c0 4.4-3 7.6-7 9-4-1.4-7-4.6-7-9V6l7-3z" />
    <circle cx="12" cy="10" r="2.2" />
    <path d="M8.5 16c.6-1.8 2-2.6 3.5-2.6s2.9.8 3.5 2.6" />
  </Basis>
);

export const IconMangel = (p: IconProps) => (
  <Basis {...p}>
    <path d="M10.3 4.3 2.5 18a1.5 1.5 0 0 0 1.3 2.2h16.4a1.5 1.5 0 0 0 1.3-2.2L13.7 4.3a1.5 1.5 0 0 0-2.6 0z" />
    <path d="M12 9v4" />
    <path d="M12 17h.01" />
  </Basis>
);

export const IconSteuer = (p: IconProps) => (
  <Basis {...p}>
    <path d="M6 3h9l3 3v15a0 0 0 0 1 0 0H6a0 0 0 0 1 0 0V3z" />
    <path d="M14 3v4h4" />
    <path d="M14.5 11.5l-5 5" />
    <path d="M10 12h.01M15 16h.01" />
  </Basis>
);

export const IconMassnahme = (p: IconProps) => (
  <Basis {...p}>
    <path d="M9 4h6a1 1 0 0 1 1 1v1H8V5a1 1 0 0 1 1-1z" />
    <path d="M8 5H6a1 1 0 0 0-1 1v13a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-2" />
    <path d="M9 13l2 2 4-4" />
  </Basis>
);

export const IconRechner = (p: IconProps) => (
  <Basis {...p}>
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <path d="M8 7h8" />
    <path d="M8 11h.01M12 11h.01M16 11h.01M8 15h.01M12 15h.01M16 15h.01M8 19h.01M12 19h.01" />
  </Basis>
);

export const IconAuswertung = (p: IconProps) => (
  <Basis {...p}>
    <path d="M12 3a9 9 0 1 0 9 9h-9V3z" />
    <path d="M14 3.5a9 9 0 0 1 6.5 6.5H14V3.5z" />
  </Basis>
);

export const IconBelege = (p: IconProps) => (
  <Basis {...p}>
    <path d="M4 7V5a1 1 0 0 1 1-1h2" />
    <path d="M20 7V5a1 1 0 0 0-1-1h-2" />
    <path d="M4 17v2a1 1 0 0 0 1 1h2" />
    <path d="M20 17v2a1 1 0 0 1-1 1h-2" />
    <path d="M3 12h18" />
  </Basis>
);

export const IconWartung = (p: IconProps) => (
  <Basis {...p}>
    <path d="M14.7 6.3a3.5 3.5 0 0 0-4.6 4.6l-6 6a1.7 1.7 0 0 0 2.4 2.4l6-6a3.5 3.5 0 0 0 4.6-4.6l-2.1 2.1-2-2 2.1-2.1z" />
    <path d="M6.5 18.5h.01" />
  </Basis>
);

export const IconAkte = (p: IconProps) => (
  <Basis {...p}>
    <path d="M3 7a2 2 0 0 1 2-2h4l2 2h8a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V7z" />
    <path d="M3 10h18" />
  </Basis>
);

export const IconZaehler = (p: IconProps) => (
  <Basis {...p}>
    <path d="M12 21a9 9 0 1 0-9-9" />
    <path d="M3 12h2M12 3v2M19 12h2" />
    <path d="M12 12l3.5-3.5" />
    <circle cx="12" cy="12" r="1.4" />
  </Basis>
);

export const IconMieter = (p: IconProps) => (
  <Basis {...p}>
    <circle cx="9" cy="8" r="3.2" />
    <path d="M3.5 20a5.5 5.5 0 0 1 11 0" />
    <path d="M16 5.5a3.2 3.2 0 0 1 0 6" />
    <path d="M17.5 14.6A5.5 5.5 0 0 1 20.5 20" />
  </Basis>
);

export const IconEinstellungen = (p: IconProps) => (
  <Basis {...p}>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09A1.7 1.7 0 0 0 8.9 19.3a1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.7 1.7 0 0 0 4.7 15a1.7 1.7 0 0 0-1.56-1.03H3a2 2 0 1 1 0-4h.09A1.7 1.7 0 0 0 4.7 8.9a1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.7 1.7 0 0 0 9 4.6a1.7 1.7 0 0 0 1-1.56V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.03 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.7 1.7 0 0 0 19.4 9v.1a1.7 1.7 0 0 0 1.56 1h.04a2 2 0 1 1 0 4H21a1.7 1.7 0 0 0-1.6 1z" />
  </Basis>
);

export const IconSonne = (p: IconProps) => (
  <Basis {...p}>
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4" />
  </Basis>
);

export const IconMond = (p: IconProps) => (
  <Basis {...p}>
    <path d="M20 14.2A8.2 8.2 0 0 1 9.8 4 8.2 8.2 0 1 0 20 14.2z" />
  </Basis>
);

export const IconPlus = (p: IconProps) => (
  <Basis {...p}>
    <path d="M12 5v14M5 12h14" />
  </Basis>
);

export const IconPfeilLinks = (p: IconProps) => (
  <Basis {...p}>
    <path d="M15 19l-7-7 7-7" />
  </Basis>
);

export const IconPfeilRechts = (p: IconProps) => (
  <Basis {...p}>
    <path d="M9 5l7 7-7 7" />
  </Basis>
);

export const IconHaken = (p: IconProps) => (
  <Basis {...p}>
    <path d="M4.5 12.5l5 5 10-11" />
  </Basis>
);

export const IconHinweis = (p: IconProps) => (
  <Basis {...p}>
    <path d="M10.3 3.9 1.9 18a2 2 0 0 0 1.7 3h16.8a2 2 0 0 0 1.7-3L13.7 3.9a2 2 0 0 0-3.4 0z" />
    <path d="M12 9v4M12 17h.01" />
  </Basis>
);

export const IconInfo = (p: IconProps) => (
  <Basis {...p}>
    <circle cx="12" cy="12" r="9" />
    <path d="M12 11v5M12 8h.01" />
  </Basis>
);

export const IconEntfernen = (p: IconProps) => (
  <Basis {...p}>
    <path d="M4 7h16M9 7V5h6v2M6 7l1 13h10l1-13" />
    <path d="M10 11v6M14 11v6" />
  </Basis>
);

export const IconBrief = (p: IconProps) => (
  <Basis {...p}>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="M3.5 7l8.5 6 8.5-6" />
  </Basis>
);

export const IconSchild = (p: IconProps) => (
  <Basis {...p}>
    <path d="M12 3l7 3v6c0 4.4-3 8.2-7 9-4-.8-7-4.6-7-9V6l7-3z" />
    <path d="M9.5 12.2l1.8 1.8 3.4-3.6" />
  </Basis>
);

export const IconMehr = (p: IconProps) => (
  <Basis {...p}>
    <rect x="4" y="4" width="6.5" height="6.5" rx="1.5" />
    <rect x="13.5" y="4" width="6.5" height="6.5" rx="1.5" />
    <rect x="4" y="13.5" width="6.5" height="6.5" rx="1.5" />
    <rect x="13.5" y="13.5" width="6.5" height="6.5" rx="1.5" />
  </Basis>
);
